import { Backend } from '@shared/datastore/core';
import { SearchMyContactsResultAjax } from './search-my-contacts.backend-model';

declare module '../core/backend' {
  interface BackendAjaxFetchTypes {
    searchMyContacts: SearchMyContactsResultAjax;
  }
}

export const searchMyContactsBackend: Backend<'searchMyContacts'> = {
  fetch: () => ({
    endpoint: `search/myContacts.php`,
    isGaf: true,
    params: {},
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/search-my-contacts/search-my-contacts.backend.ts